import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { layoutActions } from '../store';
import {
  Grid, makeStyles, Typography, FormControlLabel, Checkbox, Box, Modal, TextField, Button, Snackbar, MenuItem, Select, useMediaQuery,
} from '@material-ui/core';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper
} from "@mui/material";
import { api_call, empty, getLocalTimezone, get_data_value, get_utc_timestamp_ms, isGpsMT2VProtocolDevice, isGpsMT3VProtocolDevice, returnMobileApp, trimPhone } from '../helpers/untils';
import { DEFAULT_LOW_BATTERY_VOLT, DEFAULT_M_SOUND, NOTIFICATION_SOUND_LIST } from '../config/constant';
import { Stack } from '@mui/material';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

import TimezoneAutoCompleteDropdown from '../components/TimezoneAutoCompleteDropdown';
import SelectField from '../form/SelectField';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '1200px',
  maxHeight: '90vh',
  overflow: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  // On phones the centered/transform layout gets cropped by the on-screen keyboard
  // (the browser can't scroll a transform-centered absolute box to the focused input).
  // Pin the modal to the top-left, fill the screen, and let the box itself scroll so
  // a focused input can be scrolled up above the keyboard.
  '@media (max-width:600px)': {
    top: 0,
    left: 0,
    transform: 'none',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    maxHeight: '100%',
    p: 2,
    // Clear the fixed BottomMenu (MUI BottomNavigation, ~56px) plus the device
    // safe-area inset, so the Save/Close buttons can scroll fully into view
    // instead of being cropped behind the bottom bar.
    pb: 'calc(56px + env(safe-area-inset-bottom, 0px) + 16px)',
  },
};
const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
    maxWidth: '400px',
    margin: 'auto',
    '@media (max-width:600px)': {
      marginBottom: '60px',
    }
  },
  formContainer: {
    display: 'block',
    width: '100%',
    minWidth: '600px',
    // On phones the fixed min-width forces the whole modal to scroll horizontally;
    // drop it so the stacked card layout can fit the viewport.
    '@media (max-width:600px)': {
      minWidth: 'unset'
    }
  },
  formNotifierRect: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f7f7f7',
    padding: '8px',
    marginBottom: '16px'
  },
  formNotifierTimezoneRect: {
    width: '220px',
  },
  formRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  checkboxBlock: {
    width: 250,
  },
  inputBlock: {
    flex: 1,
  },
  checkboxOnlyBlock: {
    width: 100,
    display: 'none', //'flex'
    justifyContent: 'center',
  },
  formNotifier: {
    display: 'block',
    padding: '16px',
  },
  formNotifierLabel: {
    minWidth: '75px'
  },
  formNotifierItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  }
}));

const LOCAL_TIMEZONE = getLocalTimezone()

const NotificationForm = (props) => {
  const { open, setOpen, selectedDevice, updateTimestamp, setDeviceItem } = props;
  const user = useSelector((state) => state.session.user);

  const firstSetting = useRef(false)

  const classes = useStyles();
  const history = useHistory()

  const [timezone, setTimezone] = useState(LOCAL_TIMEZONE);

  useEffect(() => {
    initNotificationSettings();
  }, [selectedDevice, updateTimestamp])

  useEffect(() => {
    if (selectedDevice?.timezone) {
      setTimezone(selectedDevice?.timezone)
    }
  }, [selectedDevice?.timezone])

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [apiLoading, setApiLoading] = useState(false)

  ///////////////////////////////////////////////////////////////////

  const handleSaveTimezoneSetting = async (option) => {
    const url = `/api/devices/notificationTimezone`;
    const payload = {
      user_id: user.id,
      device_id: selectedDevice['id'],
      timezone: option,
    }
    setApiLoading(true)
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    setApiLoading(false)
    if (response.ok) {
      setDeviceItem({ ...selectedDevice, timezone: option })
      setToastMessage(`Timezone setting has been updated successfully`);
      setSnackbarOpen(true);
    } else {
      setToastMessage(`Unknown error`);
      setSnackbarOpen(true);
    }
  }

  const getNotificationTypeList = () => {
    const mt2v_o_notification_type_list = [
      {
        label: 'Unlocked by Bluetooth',
        value: 'Unlocked_by_Bluetooth',
        desc: ""
      },
      {
        label: 'Locked by Bluetooth',
        value: 'Locked_by_Bluetooth',
        desc: ""
      },
      {
        label: 'Bluetooth On',
        value: 'Bluetooth_On',
        desc: ""
      },
      {
        label: 'Bluetooth Off',
        value: 'Bluetooth_Off',
        desc: ""
      },
      {
        label: 'Low Battery',
        value: 'Low_Battery',
        desc: ""
      },
      {
        label: 'Hood',
        value: 'Hood',
        desc: ""
      },
      {
        label: 'Door',
        value: 'Door',
        desc: ""
      }
    ]
    let notification_type_list = [
      {
        label: 'Unlock',
        value: 'Unlock',
        desc: "Unlock Command Sent"
      },
      {
        label: 'Lock',
        value: 'Lock',
        desc: "Lock Command Sent"
      },
      {
        label: 'Horn',
        value: 'Horn',
        desc: "Horn Command Sent"
      },
      {
        label: 'Unkill',
        value: 'Unkill',
        desc: "Unkill Command Sent"
      },
      {
        label: 'Kill',
        value: 'Kill',
        desc: "Kill Command Sent"
      },
      {
        label: 'Overspeed',
        value: 'Overspeed',
        desc: "Car Is Speeding"
      },
      // {
      //   label: 'Geofence',
      //   value: 'Geofence'
      // },
      {
        label: 'Offline',
        value: 'Offline',
        desc: "Device Shows Offline"
      },
      {
        label: 'Smoking',
        value: 'Smoking',
        desc: "Smoke Detected"
      },
      {
        label: 'Over Miles',
        value: 'Overmiles',
        desc: "Alotted Miles Exceeded"
      }
    ]
    const uniqueId = selectedDevice.uniqueId
    if (isGpsMT2VProtocolDevice(uniqueId)) {
      notification_type_list = [
        ...notification_type_list,
        ...mt2v_o_notification_type_list
      ]
    }
    if (isGpsMT3VProtocolDevice(uniqueId)) {
      notification_type_list = [
        ...notification_type_list,
        {
          label: 'Shock',
          value: 'Shock',
          desc: ""
        }
      ]
    }

    notification_type_list = [
      ...notification_type_list,
      {
        label: 'Device Suspension',
        value: 'Device_Suspension',
        desc: "Device Has Been Suspended"
      },
      {
        label: 'Ignition On',
        value: 'Ignition_ACC',
        desc: "Ignition Turned On"
      },
      {
        label: 'No Position Update',
        value: 'No_Position_Update',
        desc: "Car Position has not updated in 3+ Hours"
      },
      {
        label: 'No Trip Movement',
        value: 'No_Trip_Movement',
        desc: "No Trip Scheduled But Car Is Moving"
      },
      {
        label: 'Possible Towing',
        value: 'Possible_Towing',
        desc: "Ignition Is Off But Car Is Moving"
      },
      {
        label: 'Severe Weather',
        value: 'Severe_Weather',
        desc: "Severe Weather Expected Within An Hour"
      },
      {
        label: 'Late Pickup',
        value: 'Late_Pickup',
        desc: "At trip start time + deadline , if the car is still in one of the geofence, execute the commands which were checked. - Nofify as per Late pickup"
      },
      {
        label: 'Late Return',
        value: 'Late_Return',
        desc: "At trip end time + deadline, if the car is not in one of the geofence, execute the commands which were checked. Notify as per late return"
      }
    ]
    return notification_type_list
  }
  const notificationTypeList = getNotificationTypeList()

  const [notificationSettingList, setNotificationSettingList] = useState({});
  const [errorEmailFields, setErrorEmailFields] = useState([]);

  const initNotificationSettings = () => {
    let notificationSettings = selectedDevice.notificationSettings
    if (!empty(notificationSettings)) {
      notificationSettings = JSON.parse(notificationSettings)
      notificationTypeList.map((item) => {
        if (notificationSettings[item.value] != undefined && notificationSettings[item.value]['status'] && notificationSettings[item.value]['notifyEmail'] == undefined && notificationSettings[item.value]['notifyPush'] == undefined) {
          notificationSettings[item.value]['notifyEmail'] = true
        }
      })
      firstSetting.current = false
    } else {
      notificationSettings = {}
      firstSetting.current = true
    }
    //console.log("firstSetting, notificationSettings:::::", firstSetting.current, notificationSettings)
    setNotificationSettingList(notificationSettings)
  }

  const onChangeNotificationSettingStatus = (type, event, notifyType) => {
    const settings = { ...notificationSettingList }
    if (empty(settings[type])) {
      settings[type] = {
        status: false,
        email: '',
        post_on_turo: false,
        notifyEmail: false,
        notifyPush: false,
        pushSound: DEFAULT_M_SOUND
      }
    }
    if (notifyType === 'email') {
      settings[type]['notifyEmail'] = event.target.checked
      settings[type]['status'] = event.target.checked
    } else if (notifyType === 'push') {
      settings[type]['notifyPush'] = event.target.checked
    } else if (notifyType === 'pushSound') {
      settings[type]['pushSound'] = event.target.value
    }

    setNotificationSettingList(settings)
  }
  const onChangeNotificationSettingEmail = (type, event) => {
    const settings = { ...notificationSettingList }
    if (false && firstSetting.current) {
      bulkUpdateNotificationSettingEmail(event)
    } else {
      if (empty(settings[type])) {
        settings[type] = {
          status: false,
          email: '',
          post_on_turo: false
        }
      }
      settings[type]['email'] = event.target.value
      setNotificationSettingList(settings)
    }
  }

  const onChangeNotificationSettingValue = (type, event) => {
    const settings = { ...notificationSettingList }
    if (empty(settings[type])) {
      settings[type] = {
        status: false,
        email: '',
        value: '',
        post_on_turo: false,
        notifyEmail: false,
        notifyPush: false
      }
    }
    settings[type]['value'] = event.target.value
    setNotificationSettingList(settings)
  }

  const onChangeNotificationSettingPostOnTuro = (type, event) => {
    const settings = { ...notificationSettingList }
    if (empty(settings[type])) {
      settings[type] = {
        status: false,
        email: '',
        post_on_turo: false
      }
    }
    settings[type]['post_on_turo'] = event.target.checked
    setNotificationSettingList(settings)
  }

  const bulkUpdateNotificationSettingEmail = (event) => {
    const val = event.target.value
    const settings = { ...notificationSettingList }
    for (let k in notificationTypeList) {
      const typeInfo = notificationTypeList[k]
      const type = typeInfo['value']
      if (empty(settings[type])) {
        settings[type] = {
          status: false,
          email: val,
          post_on_turo: false
        }
      } else {
        settings[type]['email'] = val
      }
    }
    setNotificationSettingList(settings)
  }

  const handleSaveSetting = async () => {
    const url = `/api/devices/notificationSetting`;
    const payload = {
      user_id: user.id,
      user_name: user.name,
      device_id: selectedDevice['id'],
      notificationSettingList: JSON.stringify(notificationSettingList),
    }
    // if (Number(payload['amount']) <= 0) {
    //   setToastMessage(`Invalid amount`);
    //   setSnackbarOpen(true);
    //   return false
    // }
    setApiLoading(true)
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    setApiLoading(false)
    if (response.ok) {
      setToastMessage(`Notification setting has been updated successfully`);
      setSnackbarOpen(true);
    } else {
      const errorMsg = response?.message ?? (response?.error ?? "Internal server error");
      setToastMessage(errorMsg);
      setSnackbarOpen(true);
      const errorFields = response.errorFields || [];
      setErrorEmailFields(errorFields);
    }
  }

  const onClickCopyToAllCars = async () => {
    const url = `/api/devices/copyNotificationSettingToAll`;
    const payload = {
      user_id: user.id,
      user_name: user.name,
      device_id: selectedDevice['id'],
      notificationSettingList: JSON.stringify(notificationSettingList),
    }
    setApiLoading(true)
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    setApiLoading(false)
    if (response.ok) {
      setToastMessage(`Notification setting has been copied to all cars successfully`);
      setSnackbarOpen(true);
    } else {
      setToastMessage(`Unknown error`);
      setSnackbarOpen(true);
    }
  }

  const checkPostOnTuroChecked = (itemType) => {
    if (notificationSettingList[itemType.value]) {
      if (notificationSettingList[itemType.value]['post_on_turo']) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  const yourphonenumber = user.phone ? trimPhone(user.phone) : "yourphonenumber"
  const [showTooltip, setShowTooltip] = useState(true) //todo quan

  // On phones the 5-column table doesn't fit, so we render each notification type as a
  // stacked card instead. 600px matches the modal's mobile breakpoint in modalStyle.
  const isMobile = useMediaQuery('(max-width:600px)')

  // Wait for the mobile keyboard to finish opening, then scroll the focused input into
  // view so it isn't cropped behind the keyboard.
  const handleEmailInputFocus = (event) => {
    const target = event.target
    setTimeout(() => {
      target.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }, 300)
  }

  // Low-battery threshold field, shared by the Push/Email cells and the mobile cards.
  const renderLowBatteryVolt = (itemType) => (
    <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '-8px' }}>
      <TextField
        margin="small"
        value={notificationSettingList[itemType.value] ? get_data_value(notificationSettingList[itemType.value], 'value', DEFAULT_LOW_BATTERY_VOLT) : DEFAULT_LOW_BATTERY_VOLT}
        onChange={(event) => onChangeNotificationSettingValue(itemType.value, event)}
        label=""
        variant="filled"
        type="number"
        style={{ width: '50px' }}
      />&nbsp;&nbsp;V
    </Stack>
  )

  const renderSoundSelect = (itemType) => (
    <Select
      variant="filled"
      value={notificationSettingList[itemType.value]?.pushSound ?? DEFAULT_M_SOUND}
      onChange={(event) => onChangeNotificationSettingStatus(itemType.value, event, 'pushSound')}
      style={{ width: '130px' }}
    >
      {
        NOTIFICATION_SOUND_LIST.map((soundItem, idx) => (
          <MenuItem key={idx} value={soundItem.value}>{soundItem.name}</MenuItem>
        ))
      }
    </Select>
  )

  const renderMobileCards = () => (
    <Box>
      {notificationTypeList.map((itemType, index) => (
        <Box key={index} sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 2, mb: 2 }}>
          <Typography sx={{ fontWeight: 600, mb: 1 }}>{itemType.label}</Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <FormControlLabel
              control={<Checkbox checked={notificationSettingList[itemType.value] && notificationSettingList[itemType.value]['notifyPush'] ? true : false}
                onChange={(event) => onChangeNotificationSettingStatus(itemType.value, event, 'push')} />}
              label={`Push`}
            />
            {(itemType.value === 'Low_Battery') && renderLowBatteryVolt(itemType)}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Typography sx={{ color: 'text.secondary' }}>Sound</Typography>
            {renderSoundSelect(itemType)}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <FormControlLabel
              control={<Checkbox checked={notificationSettingList[itemType.value] && notificationSettingList[itemType.value]['notifyEmail'] ? true : false}
                onChange={(event) => onChangeNotificationSettingStatus(itemType.value, event, 'email')} />}
              label={`Email`}
            />
            {(itemType.value === 'Low_Battery') && renderLowBatteryVolt(itemType)}
          </Box>

          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>Send Email to (separate with comma)</Typography>
              {
                (showTooltip && itemType.desc) && (
                  <Tooltip arrow title={itemType.desc}>
                    <InfoIcon color="action" fontSize="small" />
                  </Tooltip>
                )
              }
            </Box>
            <TextField
              value={notificationSettingList[itemType.value] ? notificationSettingList[itemType.value]['email'] : ''}
              onChange={(event) => onChangeNotificationSettingEmail(itemType.value, event)}
              onFocus={handleEmailInputFocus}
              label=""
              variant="filled"
              fullWidth
            />
          </Box>
        </Box>
      ))}
    </Box>
  )

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={1500}
        message={toastMessage}
      />

      <div className={classes.formContainer}>
        <div className={classes.formNotifierRect}>
          {/* <div className={classes.formNotifier}>
            <div className={classes.formNotifierItem}>
              <span className={classes.formNotifierLabel}>{`T-Mobile:`}</span>
              <span>{`${yourphonenumber}@tmomail.net`}</span>
            </div>
            <div className={classes.formNotifierItem}>
              <span className={classes.formNotifierLabel}>{`Verizon:`}</span>
              <span>{`${yourphonenumber}@vtext.com`}</span>
            </div>
          </div> */}

          <div className={classes.formNotifierTimezoneRect}>
            <Grid item xs={24} sm={24}>
              <TimezoneAutoCompleteDropdown
                device={selectedDevice}
                timezone={timezone}
                setTimezone={setTimezone}
                handleChangeTimezone={(v) => handleSaveTimezoneSetting(v)}
              />
            </Grid>
          </div>
        </div>

        <Box className={classes.formBox}>
          {isMobile ? renderMobileCards() : (
            <TableContainer sx={{ minWidth: '912px', maxHeight: `calc(100vh - 500px)` }}>
              <Table stickyHeader className="" size="small" style={{ marginBottom: 0 }}>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Push</TableCell>
                    <TableCell>Sound</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Send Email to (separate with comma)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notificationTypeList.map((itemType, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography>
                          {itemType.label}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ width: '100%', height: '100%', display: 'flex' }}>
                          <FormControlLabel
                            control={<Checkbox checked={notificationSettingList[itemType.value] && notificationSettingList[itemType.value]['notifyPush'] ? true : false}
                              onChange={(event) => onChangeNotificationSettingStatus(itemType.value, event, 'push')} />}
                            label={``}
                          />
                          {(itemType.value === 'Low_Battery') && (
                            <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '-8px' }}>
                              <TextField
                                margin="small"
                                value={notificationSettingList[itemType.value] ? get_data_value(notificationSettingList[itemType.value], 'value', DEFAULT_LOW_BATTERY_VOLT) : DEFAULT_LOW_BATTERY_VOLT}
                                onChange={(event) => onChangeNotificationSettingValue(itemType.value, event)}
                                label=""
                                variant="filled"
                                type="number"
                                style={{ width: '50px' }}
                              />&nbsp;&nbsp;V
                            </Stack>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Select
                          variant="filled"
                          value={notificationSettingList[itemType.value]?.pushSound ?? DEFAULT_M_SOUND}
                          onChange={(event) => onChangeNotificationSettingStatus(itemType.value, event, 'pushSound')}
                          style={{ width: '130px' }}
                        >
                          {
                            NOTIFICATION_SOUND_LIST.map((soundItem, idx) => (
                              <MenuItem key={idx} value={soundItem.value}>{soundItem.name}</MenuItem>
                            ))
                          }
                        </Select>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ width: '100%', height: '100%', display: 'flex' }}>
                          <FormControlLabel
                            control={<Checkbox checked={notificationSettingList[itemType.value] && notificationSettingList[itemType.value]['notifyEmail'] ? true : false}
                              onChange={(event) => onChangeNotificationSettingStatus(itemType.value, event, 'email')} />}
                            label={``}
                          />
                          {(itemType.value === 'Low_Battery') && (
                            <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '-8px' }}>
                              <TextField
                                margin="small"
                                value={notificationSettingList[itemType.value] ? get_data_value(notificationSettingList[itemType.value], 'value', DEFAULT_LOW_BATTERY_VOLT) : DEFAULT_LOW_BATTERY_VOLT}
                                onChange={(event) => onChangeNotificationSettingValue(itemType.value, event)}
                                label=""
                                variant="filled"
                                type="number"
                                style={{ width: '50px' }}
                              />&nbsp;&nbsp;V
                            </Stack>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{
                          display: 'flex',
                          width: '100%',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}>

                          {
                            (showTooltip && itemType.desc) && (
                              <Tooltip
                                arrow
                                title={itemType.desc}
                              >
                                <InfoIcon color="action" />
                              </Tooltip>
                            )
                          }
                          <TextField
                            value={notificationSettingList[itemType.value] ? notificationSettingList[itemType.value]['email'] : ''}
                            onChange={(event) => onChangeNotificationSettingEmail(itemType.value, event)}
                            onFocus={handleEmailInputFocus}
                            label=""
                            variant="filled"
                            fullWidth
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </div>

      {
        (!user.administrator) ? (
          <>
            <div style={{ padding: '15px' }}>
              <Stack direction={`row`} justifyContent={`center`} alignItems={`center`}>
                <Button type="button" color="secondary" variant="outlined" style={{ height: 'auto' }} onClick={() => onClickCopyToAllCars()} disabled={apiLoading}>
                  Copy Settings To All My Cars
                </Button>
              </Stack>
            </div>
          </>
        ) : (
          <></>
        )
      }

      <div className={classes.buttons}>
        <Button type="button" color="primary" variant="contained" onClick={() => handleSaveSetting()} disabled={apiLoading}>
          Save
        </Button>
        <Button type="button" color="primary" variant="outlined" onClick={async () => {
          var fromMobile = localStorage.getItem("fromMobile");
          if (fromMobile) {
            returnMobileApp(history);
          } else {
            setOpen(false);
          }
        }
        }>
          Close
        </Button>
      </div>
    </>
  )
}
const NotificationModal = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.user);
  const { open, setOpen, deviceItem } = props;
  const [item, setItem] = useState(null);

  useEffect(() => {
    if (deviceItem && deviceItem.id && open) {
      loadDeviceInfo(deviceItem.id);
    }
  }, [deviceItem, open])

  const loadDeviceInfo = async (deviceId) => {
    const url = `/api/devices/${deviceId}`
    const response = await api_call(url);
    if (response.ok) {
      const device = await response.json()
      setItem(device);
      setUpdateTimestamp(get_utc_timestamp_ms())
    }
  }
  const [updateTimestamp, setUpdateTimestamp] = useState(0)

  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    if (open) {
      dispatch(layoutActions.closeDeviceListMenu());
    }
  }, [open]);
  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////
  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />

          <Typography id="modal-modal-title" variant="h6" component="h2">Notification</Typography>

          <div className='mt-3' style={{ overflow: "auto" }}>
            {
              (!empty(item)) ? (
                <div className=''>
                  <NotificationForm
                    open={open}
                    setOpen={setOpen}
                    selectedDevice={item}
                    updateTimestamp={updateTimestamp}
                    setUpdateTimestamp={setUpdateTimestamp}
                    setDeviceItem={setItem}
                  />
                </div>
              ) : (
                <div className='text-center'>
                  Loading....
                </div>
              )
            }
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default NotificationModal;
